export default {
  path: "customers",
  name: "Customers",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      component: () => import("@/views/customers/Index.vue"),
    },
    {
      path: "create_customer",
      name: "Create Customer",
      component: () => import("@/views/customers/CreateCustomer.vue"),
    },
    {
      path: "customer_payment",
      name: "Payment",
      component: () =>
        import("@/views/customers/view-customer/payments/paymentPage.vue"),
    },
    {
      path: "customer_activation",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          name: "Customer Activation",
          component: () =>
            import("@/views/customers/customerActivation/index.vue"),
          redirect: "/customers/customer_activation/sim-info",
          children: [
            {
              path: "sim-info",
              name: "Sim Info",
              component: () =>
                import(
                  "@/views/customers/customerActivation/simInformation.vue"
                ),
            },
            {
              path: "plan-info",
              name: "Plan Info",
              component: () =>
                import("@/views/customers/customerActivation/planInfo.vue"),
            },
            {
              path: "customer-info",
              name: "Customer Info",
              component: () =>
                import("@/views/customers/customerActivation/customerInfo.vue"),
            },
            {
              path: "contract-review",
              name: "Contract Review",
              component: () =>
                import(
                  "@/views/customers/customerActivation/contractReview.vue"
                ),
            },
            {
              path: "payment",
              name: "Activate Payment",
              component: () =>
                import("@/views/customers/customerActivation/payment.vue"),
            },
            {
              path: "payment/:orderId",
              name: "Activate Payment",
              component: () =>
                import("@/views/customers/customerActivation/payment.vue"),
            },
            {
              path: "confirm",
              name: "Activate Confirm",
              component: () =>
                import("@/views/customers/customerActivation/confirm.vue"),
            },
          ],
        },
      ],
      // component: () => import("@/views/customers/customerActivation/index.vue"),
    },
    {
      path: "view_customer/:id",
      name: "View Customer",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/customers/view-customer/Index.vue"),
        },
        {
          path: "buySim/:id",
          name: "Buy Sim",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import("@/views/customers/view-customer/ServiceOverview/buySim"),
        },
        {
          path: "viewfinancialtran/:id/:clientId",
          name: "View Financial Transaction",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import("@/views/customers/view-customer/accounts/ViewAccount.vue"),
        },
        {
          path: "view_order/:id/:orderId",
          name: "View Order",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import("@/views/customers/view-customer/view-order/Index.vue"),
        },
        {
          path: "view_statement/:id",
          name: "View Statement",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import(
              "@/views/customers/view-customer/statement/view-statement/Index.vue"
            ),
        },
        {
          path: "createticket/:id",
          name: "Create Ticket",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import("@/views/customers/view-customer/ticket/CreateTicket"),
        },
        {
          path: "editticket/:id/:ticketId",
          name: "Edit Ticket",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import("@/views/customers/view-customer/ticket/EditTicket"),
        },
        {
          path: "viewticket/:id/:ticketId",
          name: "Customer View Ticket",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import("@/views/customers/view-customer/ticket/CustomerViewTicket"),
        },
        {
          path: "addticket/:ticketId",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Ticket Task",
              component: () =>
                import(
                  "@/views/customers/view-customer/ticketTask/TicketTask.vue"
                ),
              meta: {
                hideBreadcrumb: true,
              },
            },
            {
              path: "createtickettask",
              name: "Create Ticket Task",
              meta: {
                hideBreadcrumb: true,
              },
              component: () =>
                import(
                  "@/views/customers/view-customer/ticketTask/CreateTicketTask.vue"
                ),
            },
            {
              path: "edittickettask/:subTaskId",
              name: "Edit Ticket Task",
              meta: {
                hideBreadcrumb: true,
              },
              component: () =>
                import(
                  "@/views/customers/view-customer/ticketTask/EditTicketTask.vue"
                ),
            },
          ],
        },
        {
          path: "paymentDetails/:id",
          name: "PaymentDetails",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import(
              "@/views/customers/view-customer/payments/paymentDetails.vue"
            ),
        },
        {
          path: "cdrDetail/:id",
          name: "CDRDetail",
          meta: {
            hideBreadcrumb: true,
          },
          component: () =>
            import("@/views/customers/view-customer/activitylog/cdrInfo.vue"),
        },
      ],
    },
  ],
};
